import Profile from "../../components/MyProfile/index";
import { connect } from "react-redux";
import {
  getStates,
  getTimezone,
  getCompanyLogo,
  updateProfile,
  setStatus,
  updateLogo,
  updatePhoto,
  changePassword,
} from "../../actions/Profile";
import { getIndustryOptions } from "../../actions/Clients";
import { getDepartment } from "../../actions/CreateAccount";
import { getRoles } from "../../actions/employees";
import { getCurrentUserProfile, getUserAvatar } from "../../actions/App";

const mapStateToProps = state => {
  const {
    data,
    allstates,
    timezone,
    company_logo,
    ifUpdateSuccess,
    update_logo_msg,
    update_photo_msg,
    change_password_error_msg,
    update_error_message,
  } = state.myProfile;
  const { department } = state.create_account;
  const { roles } = state.employees;
  const { loginUserDetail, token, avatar, roleName } = state.app;
  const { industryOptions } = state.clients;
  return {
    data,
    roles,
    department,
    loginUserDetail,
    allstates,
    timezone,
    company_logo,
    token,
    ifUpdateSuccess,
    avatar,
    update_logo_msg,
    update_photo_msg,
    change_password_error_msg,
    update_error_message,
    roleName,
    industryOptions,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDepartment: () => {
      dispatch(getDepartment());
    },
    getRoles: () => {
      dispatch(getRoles());
    },
    getStates: () => {
      dispatch(getStates());
    },
    getTimezone: () => {
      dispatch(getTimezone());
    },
    getCompanyLogo: id => {
      dispatch(getCompanyLogo(id));
    },
    updateProfile: obj => {
      dispatch(updateProfile(obj));
    },
    setStatus: value => {
      dispatch(setStatus(value));
    },
    getUserAvatar: imgFilename => {
      dispatch(getUserAvatar(imgFilename));
    },
    getCurrentUserProfile: () => {
      dispatch(getCurrentUserProfile());
    },
    updateLogo: (id, uuid) => {
      dispatch(updateLogo(id, uuid));
    },
    updatePhoto: uuid => {
      dispatch(updatePhoto(uuid));
    },
    changePassword: obj => {
      dispatch(changePassword(obj));
    },
    getIndustryOptions: () => {
      dispatch(getIndustryOptions());
    },
  };
};

const Myprofile = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Profile);

export default Myprofile;



// WEBPACK FOOTER //
// ./src/containers/Profile/Profile.js